import { requestJson } from "../api/apiClient";

const PUBLIC_BASE = "/api/v1/automap";
const ADMIN_BASE = "/api/admin/automotive/trust-safety";

function buildQs(params) {
  const entries = Object.entries(params).filter(([, v]) => v != null && v !== "");
  if (!entries.length) return "";
  return `?${new URLSearchParams(Object.fromEntries(entries)).toString()}`;
}

export function fetchListingReportContext(listingId) {
  return requestJson(`${PUBLIC_BASE}/listings/${encodeURIComponent(listingId)}/report-context`);
}

export function submitListingReport(listingId, payload) {
  return requestJson(`${PUBLIC_BASE}/listings/${encodeURIComponent(listingId)}/reports`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function fetchDealerReportContext(dealerId) {
  return requestJson(`${PUBLIC_BASE}/dealers/${encodeURIComponent(dealerId)}/report-context`);
}

export function submitDealerReport(dealerId, payload) {
  return requestJson(`${PUBLIC_BASE}/dealers/${encodeURIComponent(dealerId)}/reports`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function fetchTrustSafetyDashboard() {
  return requestJson(`${ADMIN_BASE}`);
}

export function fetchTrustSafetyReports(params = {}) {
  return requestJson(`${ADMIN_BASE}/reports${buildQs(params)}`);
}

export function fetchTrustSafetyCases(params = {}) {
  return requestJson(`${ADMIN_BASE}/cases${buildQs(params)}`);
}

export function fetchTrustSafetyCase(caseId) {
  return requestJson(`${ADMIN_BASE}/cases/${encodeURIComponent(caseId)}`);
}

export function updateTrustSafetyCase(caseId, payload) {
  return requestJson(`${ADMIN_BASE}/cases/${encodeURIComponent(caseId)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function addTrustSafetyCaseNote(caseId, payload) {
  return requestJson(`${ADMIN_BASE}/cases/${encodeURIComponent(caseId)}/notes`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function resolveTrustSafetyCase(caseId, payload) {
  return requestJson(`${ADMIN_BASE}/cases/${encodeURIComponent(caseId)}/resolve`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function dismissTrustSafetyCase(caseId, reason) {
  return requestJson(`${ADMIN_BASE}/cases/${encodeURIComponent(caseId)}/dismiss`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });
}

export function escalateTrustSafetyCase(caseId, reason) {
  return requestJson(`${ADMIN_BASE}/cases/${encodeURIComponent(caseId)}/escalate`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });
}

export function pauseListingFromCase(caseId) {
  return requestJson(`${ADMIN_BASE}/cases/${encodeURIComponent(caseId)}/pause-listing`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function suspendDealerFromCase(caseId, note) {
  return requestJson(`${ADMIN_BASE}/cases/${encodeURIComponent(caseId)}/suspend-dealer`, {
    method: "POST",
    body: JSON.stringify({ note }),
  });
}

export function fetchSuspiciousListings() {
  return requestJson(`${ADMIN_BASE}/listings`);
}

export function fetchDealerTrustQueue() {
  return requestJson(`${ADMIN_BASE}/dealers`);
}

export function fetchTrustSafetyRules() {
  return requestJson(`${ADMIN_BASE}/rules`);
}

export async function fetchListingTrustSummary(listingId) {
  const data = await requestJson(`${ADMIN_BASE}/listings/${encodeURIComponent(listingId)}/summary`);
  return data.summary;
}

export async function fetchDealerTrustSummary(dealerId) {
  const data = await requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/summary`);
  return data.summary;
}

export function dismissTrustReport(reportId) {
  return requestJson(`${ADMIN_BASE}/reports/${encodeURIComponent(reportId)}/dismiss`, {
    method: "PATCH",
    body: JSON.stringify({}),
  });
}
